export const NumberInput = ({
  value,
  min,
  max,
  onChange,
}: {
  value: number
  min: number
  max: number
  onChange: (x: number) => void
}) => {
  return (
    <>
      <button
        type="button"
        onClick={() => onChange(value - 1)}
        disabled={value === min}
      >
        -
      </button>
      {value}
      <button
        type="button"
        onClick={() => onChange(value + 1)}
        disabled={value === max}
      >
        +
      </button>
    </>
  )
}
